import { DeskPage } from '@desk-component';
import { JLLayout, JLPanelBody, JLPanelFooter } from '@jl-types';
import { Checker } from '@model';
import { PageComponents } from '@my-types';

export type AccountPageState = { tenantList: []; organList: [] };

export abstract class AccountPage<
	P,
	S extends AccountPageState,
	C extends PageComponents
> extends DeskPage<P, S, C> {
	protected abstract getModel(): any;
	protected getTenantList(): [] {
		return this.state.tenantList || [];
	}
}

export default (options: {
	visible: boolean;
	readonly: boolean;
	footer: JLPanelFooter;
}): JLLayout => {
	let {
		visible,
		readonly,
		footer
	} = options;
	return [
		{
			c: 'panel',
			header: {
				title: '账户信息'
			},
			body: {
				gridColumns: 2,
				children: [
					{
						label: '公司名称',
						row: 1,
						input: {
							id: 'companyName',
							readonly: readonly,
							maxLength:100,
							c: 'text',
							check: Checker.LUXURIANT.REQUIRED
						}
					},
					{
						label: '公司名称（英文）',
						row: 2,
						input: {
							id: 'companyNameEn',
							readonly: readonly,
							maxLength:100,
							c: 'text'
						}
					},					
					{
						label: '统一社会信用证代码',
						row: 3,
						input: {
							id: 'idNo',
							c: 'text',
							readonly: readonly,
							maxLength:18,
							check: Checker.LUXURIANT.REQUIRED
						}
					},
					{
						label: '公司注册地址',
						row: 4,
						input: {
							id: 'address',
							maxLength:100,
							c: 'text'
						}
					},
					{
						label: '经营范围',
						row: 5,
						input: {
							id: 'natureOfBusiness',
							maxLength:100,
							check: Checker.LUXURIANT.REQUIRED,
							c: 'text'
						}
					},
					{
						label: '联系人',
						row: 6,
						input: {
							id: 'contacts',
							maxLength:100,
							check: Checker.LUXURIANT.REQUIRED,
							c: 'text'
						}
					},					
					{
						label: '联系电话',
						row: 7,
						input: {
							id: 'mobile',
							c: 'text',
							maxLength:20,
							check: [
								Checker.LUXURIANT.MOBILE
							]
						}
					},
					{
						label: '联系邮箱',
						row: 8,
						input: {
							id: 'email',
							c: 'text',
							maxLength:100,
							readonly: readonly,
							check: [
								Checker.LUXURIANT.REQUIRED,
								Checker.LUXURIANT.EMAIL
							]
						}
					},
					{
						visible: visible,
						label: '邮箱验证码',
						row: 9,
						placeholder: '请输入邮箱验证码',
						input: {
							id: 'emailCode',
							check: Checker.LUXURIANT.REQUIRED,
							c: 'text'
						}
					},
					{
						visible: visible,
						label: '登录密码',
						row: 10,
						input: {
							c: 'pwd',
							id: 'password',
							check: [
								Checker.LUXURIANT.REQUIRED,
								// {
								// 	do: Checker.PREDEFINED.REGEXP,
								// 	// !"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~
								// 	// eslint-disable-next-line
								// 	with: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!"#$%&'()*+,-./:;<=>?@\[\]^_`{|}~])[^]{8,20}$/,
								// 	msg: '密码强度不足, 请仔细阅读密码规则.'
								// }
							]
						}
					},
					{
						visible: visible,
						label: '确认密码',
						row: 11,
						input: {
							c: 'pwd',
							id: 'repeatPassword',
							check: [
								Checker.LUXURIANT.REQUIRED,
								{
									do: options => {
										const { model } = options;
										return model.repeatPassword === model.password;
									},
									msg: '请保持密码相同, 并重新输入.'
								}
							]
						}
					},									
					{
						label: '上传营业执照副本',
						row: 12,
						input: {
							id: 'file',
							c: 'filePicker',
							check: {
								do: Checker.PREDEFINED.REQUIRED,
								msg: '请选择需要上传的文件.'
							},
							accept: '.jpg,.png,.jpeg,.PDF'
						}
					}
				]
			} as JLPanelBody,
			footer: footer
		}
	];
};
